import type { CSSProperties, ReactNode } from 'react'

type Size = 'lg' | 'md' | 'sm' | 'xs'

interface Props {
  children: ReactNode
  size?: Size
  className?: string
  title?: string
}

const SIZE_STYLES: Record<Size, CSSProperties> = {
  lg: { fontSize: 'clamp(1.125rem, 16cqi, 3.125rem)', lineHeight: 1.05 },
  md: { fontSize: 'clamp(1.25rem, 12cqi, 2.75rem)', lineHeight: 1.05 },
  sm: { fontSize: 'clamp(1.125rem, 9cqi, 1.875rem)', lineHeight: 1.1 },
  xs: { fontSize: 'clamp(1rem, 8cqi, 1.5rem)', lineHeight: 1.15 },
}

export default function StatNumber({ children, size = 'md', className = '', title }: Props) {
  const baseStyle = SIZE_STYLES[size]
  const value = typeof children === 'string' || typeof children === 'number' ? String(children) : undefined
  return (
    <div className="w-full min-w-0 [container-type:inline-size]">
      <p
        className={`font-bold font-sans tabular-nums tracking-tight whitespace-nowrap ${className}`}
        style={{ ...baseStyle, fontVariantNumeric: 'tabular-nums' }}
        title={title ?? value}
      >
        {children}
      </p>
    </div>
  )
}
